import { League, LeagueStatus } from '../../domain/models';

export interface LeagueEntity {
  id: string;
  name: string;
  description: string | null;
  logo_url: string | null;
  status: string;
  point_system: unknown;
  is_public: boolean;
  user_id: string;
  created_at: string;
  updated_at: string;
}

// Mapper: de Entity (DB) a Model (Domain)
export const leagueEntityToModel = (entity: LeagueEntity): League => {
  return {
    id: entity.id,
    name: entity.name,
    description: entity.description || undefined,
    logoUrl: entity.logo_url || undefined,
    status: entity.status as LeagueStatus,
    pointSystem: (() => {
      const raw = entity.point_system;
      if (Array.isArray(raw)) return raw as number[];
      if (typeof raw === 'string') {
        try { const p = JSON.parse(raw); return Array.isArray(p) ? p as number[] : []; } catch { return []; }
      }
      return [];
    })(),
    isPublic: entity.is_public ?? false,
    userId: entity.user_id,
    createdAt: new Date(entity.created_at),
    updatedAt: new Date(entity.updated_at),
  };
};

// Mapper: de Model (Domain) a Entity (DB)
export const leagueModelToEntity = (model: Partial<League>): Partial<LeagueEntity> => {
  return {
    ...(model.name !== undefined && { name: model.name }),
    ...(model.description !== undefined && { description: model.description || null }),
    ...(model.logoUrl !== undefined && { logo_url: model.logoUrl || null }),
    ...(model.status !== undefined && { status: model.status }),
    ...(model.pointSystem !== undefined && { point_system: model.pointSystem }),
    ...(model.isPublic !== undefined && { is_public: model.isPublic }),
    ...(model.userId !== undefined && { user_id: model.userId }),
  };
};
